import { Checkbox } from '../checkbox';

function ToolKitFilterItem(props) {
	let className = 'toolkit-filter--item';
	if (props.option.count === 0) {
		className += ' toolkit-filter--item--disabled';
	}

	return (
		<li className={className}>
			<Checkbox
				id={props.id + '_' + props.option.value}
				value={props.option.value}
				checked={props.isSelected}
				onChange={props.onChangeCallback}
				label={props.labelFunction(props.option.value)}
				disabled={props.option.count === 0}
			/>

			<span className="toolkit-filter--count">{props.option.count}</span>
		</li>
	)
}

export function ToolKitFilter(props) {
	const allOption = {
		value: 'all',
		count: props.allCount,
	}
	return (
		<ol className={props.className}>
			<ToolKitFilterItem
				option={allOption}
				key='all'
				id={props.id}
				labelFunction={props.labelFunction}
				onChangeCallback={props.onChangeCallback}
				isSelected={props.optionsCount === props.selectedOptions.length}
			/>
			{props.options.map(option => (
				<ToolKitFilterItem
					option={option}
					id={props.id}
					key={option.value}
					labelFunction={props.labelFunction}
					onChangeCallback={props.onChangeCallback}
					isSelected={props.selectedOptions.includes(option.value)}
				/>
			))}
		</ol>
	);
}
export default ToolKitFilter;
